import Api from './api';

const loginRequest = (user) => {
    return Api().post('/api/auth/login', user)
}
const socialLoginRequest = (data) => {
    return Api().post('/api/auth/social-login', data)
}

const logoutRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/auth/logout', {}, { headers: { Authorization: 'Bearer ' + access_token } })
}

const passwordRecovery = (data) => {
    return Api().post('/api/password/email', data)
}

const passwordReset = (data) => {
    return Api().post('/api/password/reset', data)
}

const refreshToken = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/auth/refresh', {}, { headers: { Authorization: 'Bearer ' + access_token } })
}

const checkMeRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/me', { headers: { Authorization: 'Bearer ' + access_token } })
}

const addDeposit = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/payment', data, { headers: { Authorization: 'Bearer ' + access_token } })
}


export default { loginRequest, socialLoginRequest, logoutRequest, refreshToken, passwordRecovery, passwordReset, checkMeRequest , addDeposit}



// WEBPACK FOOTER //
// ./src/api/apiAuth.js